module.exports = __webpack_public_path__ + "static/media/Engpic6@2x.2ca4ef54.png";